import React, { useEffect, useMemo } from 'react';
import PatientPage from 'pages/rpm/patients/patient';
import { isPatient } from 'utils/userTypeHelper';
import useUser from 'utils/useUser';
import ModuleProvider from 'infrastructure/providers/module-provider';
import { useNavigate, useParams } from 'react-router-dom';
import { isValidGuid } from 'infrastructure/functions';
import {
  patientPageAccessCcmStatuses,
  patientPageAccessRpmStatuses,
} from 'infrastructure/consts';
import { showResult } from 'infrastructure/hooks/utils';
import { useTranslation } from 'react-i18next';
import { Routes } from 'router/routes';
import { useRpmPatientDetails } from 'infrastructure/hooks/rpm';
import BaseLoader from 'components/atoms/base-loader';
import { usePatientChartSession } from 'infrastructure/hooks/patient/use-patient-chart-session';

import UnifiedPatientProfile from './index';

const PatientProfile: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { userType } = useUser();
  const { patientGuid } = useParams();

  const {
    query: { patient, isLoading },
  } = useRpmPatientDetails({ patientGuid });

  usePatientChartSession({
    patientGuid: patientGuid as string,
    userType,
  });

  const hasAccess = useMemo(() => {
    if (!patient) return false;
    const hasRpmAccess = patientPageAccessRpmStatuses.includes(
      patient.profile.status,
    );
    const hasCcmAccess = patientPageAccessCcmStatuses.includes(
      patient.profile.ccmStatus,
    );
    return hasRpmAccess || hasCcmAccess;
  }, [patient]);

  useEffect(() => {
    if (!patientGuid || !isValidGuid(patientGuid)) {
      showResult(t('errors.invalidGuid'));
      navigate(Routes.notFound, { replace: true });
    }
  }, [patientGuid, navigate]);

  useEffect(() => {
    if (patient && !hasAccess) {
      navigate(Routes.notFound, { replace: true });
    }
  }, [patient, hasAccess]);

  // useEffect(() => {
  //   if (patient && patient?.profile?.guid) {
  //     startSession({ patientGuid: patient.profile.guid });
  //   }
  // }, [patient]);

  return (
    <BaseLoader loading={isLoading || !hasAccess}>
      <ModuleProvider>
        {isPatient(userType) ? <PatientPage /> : <UnifiedPatientProfile />}
      </ModuleProvider>
    </BaseLoader>
  );
};

export default PatientProfile;
